import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

export interface AddMemberToOrganizationRequest {
  OrganizationUUID: string;
  AccessToken: string;
  IntegrationName?: string;
  UserEmail?: string;
  UserUUID?: string;
  Role?: string;
  FirstName?: string;
  LastName?: string;
  InviterUserUUID?: string;
  // Token the joiner used — attributes the join to its creator.
  InviteToken?: string;
  CompanyEmail?: string;
  // Expiry preset for the invite link embedded in the email (24h/48h/7d/30d/never).
  ExpiresIn?: string;
}

export async function addMemberToOrganization(
  request: AddMemberToOrganizationRequest
) {
  const url = `${apiUrl}addMemberToOrganization/`;

  try {
    const response = await postWithAuth(url, request);

    if (!response.ok) {
      throw new Error(`Failed to add member: ${response.statusText}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error in addMemberToOrganization:', error);
    throw error;
  }
}
